import React from "react";
import GestionRendezVous from "./GestionRendezVous";

// One responsive workspace keeps forms, details and permission checks shared.
export default function ResponsiveRendezVous(props) {
  return <GestionRendezVous {...props} />;
}
